// extracted by mini-css-extract-plugin
export default {"container":"style_container__glRJA","privacy":"style_privacy__gZkYg"};